class recordRecentlyViewedProducts extends HTMLElement {
  constructor() { super(); this.name = 'minion_recently_viewed'; }
  currentHandle() {
    const match = window.location.pathname.match(/\/products\/([^/]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }
  history() {
    try {
      const item = document.cookie.split(';').map(x => x.trim()).find(x => x.startsWith(this.name + '='));
      return [...new Set((item ? decodeURIComponent(item.slice(this.name.length + 1)) : '').split(/\s+|\|\|/).filter(x => /^[a-zA-Z0-9_-]+$/.test(x)))];
    } catch (_) { return []; }
  }
  recordRecentlyViewed() {
    const handle = this.currentHandle();
    if (!handle) return;
    const products = [handle, ...this.history().filter(x => x !== handle)].slice(0, 7);
    try { document.cookie = this.name + '=' + encodeURIComponent(products.join('||')) + '; max-age=86400; path=/; SameSite=Lax'; } catch (_) { /* History is optional. */ }
  }
  connectedCallback() { this.recordRecentlyViewed(); }
}
class recentlyViewedProducts extends recordRecentlyViewedProducts {
  connectedCallback() {
    super.connectedCallback();
    if (this.started) return;
    this.started = true;
    this.hidden = true;
    const handles = this.history().filter(x => x !== this.currentHandle()).slice(0, 6);
    if (handles.length) this.getProducts(handles);
  }
  async getProducts(handles) {
    try {
      const base = window.routes?.collections_url || '/collections';
      // En colecciones, data-card lleva los ajustes de la grilla para usar la misma tarjeta de producto.
      const tokens = [...handles];
      if (this.dataset.card) tokens.push(this.dataset.card);
      tokens.push(this.dataset.settings);
      const params = new URLSearchParams({view: 'ajax_recently_viewed', sort_by: tokens.join('||')});
      const response = await fetch(base + '/all?' + params);
      if (!response.ok) return;
      const content = this.querySelector('.recently-viewed-products-content');
      content.innerHTML = await response.text();
      if (!content.querySelector('.pp-recent-card')) return;
      this.classList.remove('hide');
      this.hidden = false;
      const track = content.querySelector('.pp-recent-track');
      const controls = content.querySelector('.pp-recent-controls');
      const prev = controls.querySelector('[data-recent-prev]');
      const next = controls.querySelector('[data-recent-next]');
      const update = () => {
        controls.hidden = track.scrollWidth <= track.clientWidth + 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      prev.onclick = () => track.scrollBy({left: -track.clientWidth, behavior: 'smooth'});
      next.onclick = () => track.scrollBy({left: track.clientWidth, behavior: 'smooth'});
      track.addEventListener('scroll', update, {passive: true});
      this.resizeObserver = new ResizeObserver(update);
      this.resizeObserver.observe(track);
      update();
    } catch (_) { this.hidden = true; }
  }
  disconnectedCallback() { this.resizeObserver?.disconnect(); this.started = false; }
}
if (!customElements.get('recently-viewed-products')) customElements.define('recently-viewed-products', recentlyViewedProducts);
if (!customElements.get('recently-viewed-products-record')) customElements.define('recently-viewed-products-record', recordRecentlyViewedProducts);
